import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modalpopup" }
const _hoisted_2 = {
  class: "modal",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "body-content" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "modal-footer template-modal-popup-footer" }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-success show-copied-message"
}
const _hoisted_16 = { class: "button-group template-modal-popup-footer-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "modal-title",
                    innerHTML: _ctx.localTemplateContentViewModel.Heading
                  }, null, 8, _hoisted_6),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    "aria-hidden": "true",
                    class: "cross-icon",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CloseModalPopup()))
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", {
                      class: "fa fa-times close-color",
                      "aria-hidden": "true"
                    }, null, -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "body-heading" }, null, -1)),
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.showLanguageDropdown)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('LanguageHeading')), 1),
                          _createElementVNode("select", {
                            class: "select-dropdown form-control selectBox sel-event-access-instruction",
                            value: _ctx.selectedLanguage,
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.TemplateLanguageChange && _ctx.TemplateLanguageChange(...args)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localLanguageList, (lang) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: lang.Id,
                                value: lang.Id
                              }, _toDisplayString(lang.Label), 9, _hoisted_12))
                            }), 128))
                          ], 40, _hoisted_11),
                          _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      ref: "templateContent",
                      class: "div-template-content",
                      innerHTML: _ctx.localTemplateContentViewModel.ModelDescription
                    }, null, 8, _hoisted_13),
                    _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.showCopiedMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[8] || (_cache[8] = _createElementVNode("i", {
                              class: "fa fa-check",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('CopiedSuccessfully')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.localTemplateContentViewModel.IsSecondaryButtonVisible)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-secondary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CloseModalPopup()))
                        }, _toDisplayString(_ctx.localTemplateContentViewModel.SecondaryButtonText), 1))
                      : _createCommentVNode("", true),
                    (_ctx.localTemplateContentViewModel.IsPrimaryButtonVisible)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-primary modal-footer-button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.CopyContentToClipboard()))
                        }, _toDisplayString(_ctx.localTemplateContentViewModel.PrimaryButtonText), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}